import { TimelineChartXScale } from './timeline-chart-scale-types';

/**
 * Maps a clamped time interval to pixel span inside the chart inner width (same rule for issues and gaps).
 */
export function getTimelineBarPixelSpan(
  xScale: TimelineChartXScale,
  innerWidth: number,
  rangeStart: Date,
  rangeEnd: Date,
): { startX: number; barWidth: number } {
  const startX = Math.max(0, xScale(rangeStart) ?? 0);
  const endX = Math.min(innerWidth, xScale(rangeEnd) ?? innerWidth);
  const barWidth = Math.max(1, endX - startX);
  return { startX, barWidth };
}
